'use strict';

const createTspanWriter = require('./tspan-writer'),
	createTextSizer = require('./text-sizer'),
	direction = require('direction'),
	svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	fontFamiliesGenerator = require('@mindmup/mapjs-core/src/theme/font-families'),
	cssFamilies = fontFamiliesGenerator();
module.exports = function TSpanTextEngine(abstractWidthFunction, LineBreaker, optional) {
	const self = this,
		fontFamilies = (optional && optional.fontFamilies) || cssFamilies,
		convertToRtl = function (attrs, lineWidth) {
			attrs['text-anchor'] = 'end';
			attrs.textLength = Math.floor(lineWidth);
			attrs.x = Math.ceil(lineWidth);
		};
	self.nodeTextDimensions = createTextSizer(abstractWidthFunction, LineBreaker);
	self.lineSize = function (text, fontMetrics) {
		return {
			width: Math.ceil(abstractWidthFunction(text, fontMetrics) * fontMetrics.fontSize),
			height: fontMetrics.fontSize
		};
	};
	self.writeLine = function (text, fontMetrics, color, justifyWidth) {
		const textElement = svgMarkupBuilder('text').css({
				fill: color
			}),
			attrs = {
				'font-family': fontFamilies[fontMetrics.family],
				'font-size': fontMetrics.fontSize,
				'font-weight': fontMetrics.weight,
				lengthAdjust: 'spacing',
				'text-anchor': 'left',
				'y': fontMetrics.fontSize
			};
		if (justifyWidth) {
			attrs['text-anchor'] = 'middle';
			attrs.textLength = Math.floor(justifyWidth);
			attrs.x = Math.ceil(justifyWidth / 2);
		}
		if (direction(text) === 'rtl') {
			convertToRtl(attrs, self.lineSize(text, fontMetrics).width);
			attrs['font-size'] = Math.floor(fontMetrics.fontSize * 0.9);
		}
		textElement.attr(attrs).text(text);
		return textElement;
	};
	self.writeNodeText = createTspanWriter(abstractWidthFunction, LineBreaker, optional);
};

